import React, { Component } from 'react'
import Link from 'gatsby-link'
import Radium from 'radium'
import HamburgerMenu from 'react-hamburger-menu'
import { colors } from './assets/shibui';

import NotificationManager from './notification-manager'

const STYLES = {
  container: {
    backgroundColor: colors.amethyst50.color,
    position: 'fixed',
    padding: '40px 0',
    zIndex: 100,
    height: '100%',
    width: '100%',
    left: 0,
    top: 0,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    alignItems: 'center'
  },
  link: {
    display: 'block',
    padding: '10px 35px',
    textDecoration: 'none',
    fontSize: '1.7rem',
    color: colors.ivory.color
  },
  sideMenuBtn: {
    position: 'fixed',
    top: 14,
    right: 12,
    zIndex: 2000,
    backgroundColor: colors.ivory.color,
    borderRadius: 4,
    padding: 8,
    boxShadow: '0 2px 2px rgba(0,0,0,.14)'
  }
}

class MobileMenu extends Component {
  constructor() {
    super()

    this.state = {
      isOpen: false
    }
  }

  handleClick() {
    this.setState({isOpen: !this.state.isOpen})
  }

  render() {
    return (
      <div style={{position: 'relative', width: '100%'}}>
        <span style={STYLES.sideMenuBtn}>
          <HamburgerMenu
            menuClicked={this.handleClick.bind(this)}
            width={22}
            isOpen={this.state.isOpen}
            height={20}
            strokeWidth={1}
            color={colors.midnight.color}
          />
        </span>
        {this.state.isOpen &&
          <div style={STYLES.container}>
            <Link style={STYLES.link} to="/">Home</Link>
            <a onClick={() => this.handleClick()} style={STYLES.link} href="https://www.haikuforteams.com/#about">About</a>
            <Link style={STYLES.link} to="/blog">Blog</Link>
          </div>
          }
        <NotificationManager />
      </div>
    )
  }
}

export default Radium(MobileMenu)



// WEBPACK FOOTER //
// ./src/components/mobile-menu.js